import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Products', path: '/products' },
    { name: 'Blog', path: '/blog' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <div className="w-10 h-10 bg-[#0A3D2E] rounded-full flex items-center justify-center">
              <span className="text-[#CDFF00] font-bold text-xl">GC</span>
            </div>
            <span className="text-xl font-bold text-[#0A3D2E] font-['Outfit']">Green Circuit EV</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-[#0A3D2E] text-white'
                    : 'text-[#4A5D54] hover:bg-[#E9F0EC] hover:text-[#0A3D2E]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            {user && user.role === 'admin' && (
              <Link
                to="/admin"
                data-testid="nav-admin"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive('/admin')
                    ? 'bg-[#0A3D2E] text-white'
                    : 'text-[#4A5D54] hover:bg-[#E9F0EC] hover:text-[#0A3D2E]'
                }`}
              >
                Admin
              </Link>
            )}
          </nav>

          <Link
            to="/contact"
            data-testid="header-cta-button"
            className="hidden md:block px-6 py-2.5 bg-[#CDFF00] text-[#0A3D2E] rounded-full font-semibold text-sm hover:bg-[#B8E600] transition-colors focus:ring-2 focus:ring-[#CDFF00] focus:outline-none"
          >
            Get a Quote
          </Link>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-[#0A3D2E] hover:bg-[#E9F0EC] rounded-lg transition-colors"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-black/5" data-testid="mobile-menu">
          <nav className="px-6 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                className={`block px-4 py-3 rounded-2xl text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-[#0A3D2E] text-white'
                    : 'text-[#4A5D54] hover:bg-[#E9F0EC]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            {user && user.role === 'admin' && (
              <Link
                to="/admin"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-admin"
                className={`block px-4 py-3 rounded-2xl text-base font-medium transition-colors ${
                  isActive('/admin')
                    ? 'bg-[#0A3D2E] text-white'
                    : 'text-[#4A5D54] hover:bg-[#E9F0EC]'
                }`}
              >
                Admin
              </Link>
            )}
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-cta-button"
              className="block text-center px-6 py-3 bg-[#CDFF00] text-[#0A3D2E] rounded-full font-semibold hover:bg-[#B8E600] transition-colors"
            >
              Get a Quote
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
